import { AxiosRequestConfig } from 'axios';
import { GetProfileContentsQuery } from '@diritto/common/api/ContentApi';
import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { BestType } from '@diritto/common/best/constants';
import { CategoryType, ContentFilterType, ContentOrderType } from '@diritto/common/content/constants';
import { RecentlyReadContentOrder } from '@diritto/common/recentlyRead/constants';
import {
  ContentListRelayResponseDto,
  ContentProfileRelayResponseDto,
  ContentRankListRelayResponseDto,
} from '@diritto/common/relay/dtos/content-relay.dtos';
import { FavoriteContentsRelayResponseDto } from '@diritto/common/relay/dtos/favorite-content-relay.dtos';
import { RecentlyReadContentsRelayResponseDto } from '@diritto/common/relay/dtos/recently-read-content-relay.dtos';
import { FavoriteContentOrder } from '@diritto/common/userReaction/constants';
import { Http } from '@diritto/common/utils/requester/http';

export interface GetContentsQuery {
  filterType: ContentFilterType;
  orderType: ContentOrderType;
  categoryId?: number; // TODO: [2025-08-29] Deprecated categoryId
  includeAdult: boolean;
  categoryIds?: string;
}

export interface GetRecentlyReadQuery {
  orderBy: RecentlyReadContentOrder;
  categoryType?: CategoryType;
  showOnlyCompleted?: boolean;
}

export interface GetFavoriteQuery {
  orderBy: FavoriteContentOrder;
  notiOnly?: boolean;
  categoryType?: CategoryType;
  showOnlyCompleted?: boolean;
  showOnlyPrivate?: boolean;
}

export interface GetBestContentsQuery {
  categoryId?: number; // TODO: [2025-08-29] Deprecated categoryId
  categoryIds?: string;
  includeAdult: boolean;
}

export class RelayContentApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getContents(
    params: BasePaginatorDto & GetContentsQuery,
    options?: AxiosRequestConfig,
  ): Promise<ContentListRelayResponseDto> {
    const res = await this.http.get<ContentListRelayResponseDto>(`${this.url}/relay/contents`, {
      params,
      ...options,
    });
    return res.data;
  }

  async getRankingContents(
    bestType: BestType,
    params: BasePaginatorDto & GetBestContentsQuery,
    options?: AxiosRequestConfig,
  ): Promise<ContentRankListRelayResponseDto> {
    const res = await this.http.get<ContentRankListRelayResponseDto>(`${this.url}/relay/contents/rank/${bestType}`, {
      params,
      ...options,
    });
    return res.data;
  }

  async getRecentlyReadContents(
    params: BasePaginatorDto & GetRecentlyReadQuery,
    options?: AxiosRequestConfig,
  ): Promise<RecentlyReadContentsRelayResponseDto> {
    const res = await this.http.get<RecentlyReadContentsRelayResponseDto>(`${this.url}/relay/recently-read/contents`, {
      params,
      ...options,
    });
    return res.data;
  }

  async getFavoriteContents(
    params: BasePaginatorDto & GetFavoriteQuery,
    options?: AxiosRequestConfig,
  ): Promise<FavoriteContentsRelayResponseDto> {
    const res = await this.http.get<FavoriteContentsRelayResponseDto>(`${this.url}/relay/favorite/contents`, {
      params,
      ...options,
    });
    return res.data;
  }

  async getProfileContents(
    profileId: number,
    params: BasePaginatorDto & GetProfileContentsQuery,
    options?: AxiosRequestConfig,
  ): Promise<ContentProfileRelayResponseDto> {
    const res = await this.http.get<ContentProfileRelayResponseDto>(
      `${this.url}/relay/contents/profiles/${profileId}`,
      {
        params,
        ...options,
      },
    );
    return res.data;
  }
}
